import { render, staticRenderFns } from "./M-Text.vue?vue&type=template&id=1edadb5d&lang=pug&"
import script from "./M-Text.vue?vue&type=script&lang=js&"
export * from "./M-Text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports